/**
 * feature-toggle.js
 * Vue mixin and functions that add feature toggling logic to a component.
 *
 *  For use in JS:
 *   import { enabled } from '@/feature-toggle';
 *   if (enabled('dataOnly')) ...
 *
 * For use in HTML templates set on methods:
     methods: {
      enabled,
      ...
     }
 *
 *
 */

import localStore from 'store';

/**
 * Enables or disables a named feature flag.
 * Persisted to localStorage (falls back to a cookie if localStorage is unavailable).
 */
export function set(featureName: string, isEnabled: boolean): void {
  localStore.set(featureName, isEnabled);
}

/**
 * Returns all stored feature flag entries as a name → enabled map.
 */
export function getAll() {
  const all: Record<string, boolean> = {};
  localStore.each((value, key) => {
    if (typeof value !== 'boolean') return;
    all[key] = value;
  });
  return all;
}

/**
 * Returns whether a named feature flag is enabled, or undefined if not set.
 */
export function enabled(featureName: string): boolean | undefined {
  return localStore.get(featureName);
}
